import { dec } from './decimal.js';
import { formatFraction } from './fraction.js';
import { roundForDisplay } from './rounding.js';
import { unitLabel } from '../units/catalog.js';
const RANGE_DASH = '–';
function fractionalCountHint(quantity, name, locale) {
    const d = dec(quantity);
    if (d.isInteger())
        return null;
    const whole = d.floor();
    const rest = d.minus(whole);
    const restText = formatFraction(rest, { locale });
    if (locale === 'de') {
        return whole.isZero()
            ? `${restText} ${name} verwenden (z. B. abgewogen oder verquirlt und geteilt)`
            : `${whole.toFixed(0)} ${name} + ${restText} ${name} verwenden (z. B. verquirlt und geteilt)`;
    }
    return whole.isZero()
        ? `use ${restText} ${name} (e.g. weighed or beaten and divided)`
        : `use ${whole.toFixed(0)} ${name} + ${restText} ${name} (e.g. beaten and divided)`;
}
export function formatQuantityAmount(input, locale = 'en') {
    if (input.quantity === null) {
        return input.quantityText?.trim() ?? '';
    }
    const unitCode = input.unitCode;
    const preferFractions = unitCode === null ||
        ['tsp', 'tbsp', 'cup', 'piece', 'floz'].includes(unitCode) ||
        dec(input.quantity).lt(10);
    const q = roundForDisplay(input.quantity, unitCode);
    let text = formatFraction(q, { locale, preferFractions });
    if (input.quantityMax !== null) {
        const qm = roundForDisplay(input.quantityMax, unitCode);
        if (qm !== q)
            text += `${RANGE_DASH}${formatFraction(qm, { locale, preferFractions })}`;
    }
    const label = unitCode
        ? unitLabel(unitCode, locale, dec(input.quantityMax ?? input.quantity).equals(1) ? 'singular' : 'plural')
        : (input.unitText ?? null);
    if (label)
        text += ` ${label}`;
    if (input.quantityText)
        text += ` (${input.quantityText.trim()})`;
    return text;
}
export function formatIngredientLine(input, locale = 'en') {
    const amount = formatQuantityAmount(input, locale);
    let line = amount ? `${amount} ${input.name}` : input.name;
    if (input.note)
        line += `, ${input.note}`;
    if (input.optional)
        line += locale === 'de' ? ' (optional)' : ' (optional)';
    const hint = input.quantity !== null && (input.unitCode === 'piece' || input.unitCode === null)
        ? fractionalCountHint(roundForDisplay(input.quantity, input.unitCode), input.name, locale)
        : null;
    return { amount, line, hint };
}
//# sourceMappingURL=display.js.map